export class TreeNodeData {
    id: number;
    // zero or one of the following two attributes may be set
    selected?: boolean;
    subTreeSelected?: boolean;
    // more optional attributes
    defaulttext?: string;
}
